/**
 * THE NAARI – Main front-end JavaScript
 *
 * @package Naari
 */

(function () {
	'use strict';

	/**
	 * Initialise Lenis smooth scroll (deferred so it does not block LCP/FCP).
	 * Only runs when naariConfig.smoothScroll is true (not on blog page).
	 * Skips when user prefers reduced motion (accessibility).
	 */
	function initLenis() {
		console.log('initLenis1');
		// Do not run on blog (posts index) page – Lenis script is not loaded there
		if (typeof window.Lenis === 'undefined') return;

		var lenis = new window.Lenis({
			anchors: true,
			smoothWheel: true,
			lerp: 0.2,
			smoothWheel: true,
			smoothTouch: true,
			wheelMultiplier: 1,
			touchMultiplier: 1.5,
			duration: 1.2,
			easing: function (t) {
				return Math.min(1, 1.001 - Math.pow(2, -10 * t));
			},
			orientation: 'vertical',
			gestureOrientation: 'vertical',
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}
		requestAnimationFrame(raf);

		window.naariLenis = lenis;

		// Sync ScrollTrigger with Lenis so scroll-driven animations use smooth scroll position
		if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined') {
			window.ScrollTrigger.scrollerProxy(document.body, {
				scrollTop: function () {
					return lenis.scroll;
				},
			});
			lenis.on('scroll', window.ScrollTrigger.update);
		}
	}

	/**
	 * Common scroll animations – add .is-in-view when elements with .animate-on-inview enter viewport.
	 * Works on all pages; respects prefers-reduced-motion. Works with Lenis smooth scroll.
	 */
	function initScrollAnimations() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		var elements = document.querySelectorAll('.animate-on-inview:not(.ritual-reveal)');
		if (!elements.length) return;

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						var el = entry.target;
						el.classList.add('is-in-view');
						var delay = el.getAttribute('data-animate-delay');
						if (delay != null && delay !== '') {
							el.style.animationDelay = delay.indexOf('s') !== -1 ? delay : delay + 's';
						}
					}
				});
			},
			{ rootMargin: '0px 0px -8% 0px', threshold: 0 }
		);

		elements.forEach(function (el) {
			observer.observe(el);
		});

		// Ritual section: center-first round reveal when ~50% in view (GSAP: hole expands from center)
		var ritualSection = document.querySelector('.home-ritual.ritual-reveal');
		var ritualOverlay = ritualSection && ritualSection.querySelector('.ritual-overlay');
		if (ritualSection && ritualOverlay) {
			var ritualDone = false;
			var ritualObserver = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (!entry.isIntersecting || ritualDone) return;
						ritualDone = true;
						ritualSection.classList.add('is-in-view');
						ritualObserver.unobserve(ritualSection);

						// Center shows first, then circle expands to full (slower: 2.2s)
						if (typeof window.gsap !== 'undefined') {
							window.gsap.fromTo(
								ritualOverlay,
								{ '--r': '0%' },
								{
									'--r': '150%',
									duration: 2.2,
									ease: 'power2.inOut',
									overwrite: 'auto',
								}
							);
						} else {
							ritualOverlay.style.setProperty('--r', '150%');
						}
					});
				},
				{ rootMargin: '0px 0px -25% 0px', threshold: 0.25 }
			);
			ritualObserver.observe(ritualSection);
		}
	}

	/**
	 * Run Lenis init after first paint (requestIdleCallback) so it does not block LCP/FCP.
	 * Fallback to setTimeout for browsers without requestIdleCallback.
	 */
	function scheduleLenisInit() {
		var run = function () {
			initLenis();
		};
		if (typeof requestIdleCallback !== 'undefined') {
			requestIdleCallback(run, { timeout: 2000 });
		} else {
			setTimeout(run, 1);
		}
	}

	/**
	 * Header – drawer menu toggle and scroll-based .bg-white class.
	 * Toggles .active on nav/header and body overflow when menu button is clicked.
	 * Adds .bg-white to header when scrollY >= 100.
	 */
	function initHeader() {
		var menuBtn = document.querySelector('.site-drawer-menu');
		var headerNav = document.querySelector('.site-header-nav');
		var header = document.querySelector('.site-header');
		var body = document.body;

		if (!menuBtn || !headerNav || !header || !body) return;

		menuBtn.addEventListener('click', function () {
			var isOpening = !headerNav.classList.contains('active');
			headerNav.classList.toggle('active');

			var lenis = window.naariLenis;

			if (isOpening) {
				if (lenis && typeof lenis.stop === 'function') {
					//lenis.stop();
				} else {
					body.style.overflow = 'hidden';
				}
				header.classList.add('bg-white');
			} else {
				if (lenis && typeof lenis.start === 'function') {
					//lenis.start();
				} else {
					body.style.overflow = '';
				}
				if (window.scrollY < 100) {
					header.classList.remove('bg-white');
				}
			}
		});

		window.addEventListener('scroll', function () {
			if (window.scrollY >= 100) {
				header.classList.add('bg-white');
			} else if (!headerNav.classList.contains('active') && !header.classList.contains('has-mega-menu-open')) {
				header.classList.remove('bg-white');
			}
		});

		initHeaderMegaMenu(header);
	}

	/**
	 * Desktop header mega submenu – hover/focus states and header background.
	 */
	function initHeaderMegaMenu(header) {
		var menuRoot = document.querySelector('.site-header-menu .nav-menu');
		if (!menuRoot) return;

		var parentItems = menuRoot.querySelectorAll('.menu-item-has-children');
		if (!parentItems.length) return;

		var closeTimer = null;

		function clearOpenState() {
			parentItems.forEach(function (item) {
				item.classList.remove('is-submenu-open');
				var panel = item.querySelector('.header-mega-menu');
				if (panel) {
					panel.setAttribute('aria-hidden', 'true');
				}
			});
			header.classList.remove('has-mega-menu-open');
			if (window.scrollY < 100 && !document.querySelector('.site-header-nav.active')) {
				header.classList.remove('bg-white');
			}
		}

		function openItem(item) {
			clearOpenState();
			item.classList.add('is-submenu-open');
			var panel = item.querySelector('.header-mega-menu');
			if (panel) {
				panel.setAttribute('aria-hidden', 'false');
			}
			header.classList.add('has-mega-menu-open', 'bg-white');
		}

		parentItems.forEach(function (item) {
			item.addEventListener('mouseenter', function () {
				if (closeTimer) {
					clearTimeout(closeTimer);
					closeTimer = null;
				}
				openItem(item);
			});

			item.addEventListener('mouseleave', function () {
				closeTimer = setTimeout(clearOpenState, 120);
			});

			item.addEventListener('focusin', function () {
				openItem(item);
			});
		});

		header.addEventListener('focusout', function (event) {
			if (header.contains(event.relatedTarget)) {
				return;
			}
			clearOpenState();
		});
	}

	/**
	 * Footer fixed image – parallax (image scrolls at different rate than page).
	 * RAF loop so it works with Lenis; uses Lenis scroll if available. Respects prefers-reduced-motion.
	 */
	function initFooterFixedImageParallax() {
		var section = document.querySelector('.footer-fixed-image');
		var img = section && section.querySelector('.footer-fixed-image__img');
		if (!section || !img) return;
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		function getScrollY() {
			if (window.naariLenis != null && typeof window.naariLenis.scroll === 'number') {
				return window.naariLenis.scroll;
			}
			return window.pageYOffset || document.documentElement.scrollTop;
		}

		function updateParallax() {
			var scrollY = getScrollY();
			var rect = section.getBoundingClientRect();
			var sectionTop = rect.top + scrollY;
			var sectionHeight = section.offsetHeight;
			var viewportHeight = window.innerHeight;

			var scrollRangeStart = sectionTop - viewportHeight;
			var scrollRangeEnd = sectionTop + sectionHeight;
			var progress = (scrollY - scrollRangeStart) / (scrollRangeEnd - scrollRangeStart);
			progress = Math.max(0, Math.min(1, progress));

			var maxShift = sectionHeight * 0.25;
			var translateY = -progress * maxShift;
			img.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
		}

		function tick() {
			updateParallax();
			requestAnimationFrame(tick);
		}
		requestAnimationFrame(tick);
	}

	function init() {
		initHeader();
		scheduleLenisInit();
		initScrollAnimations();
		initFooterFixedImageParallax();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
